import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/mode-css";
import "ace-builds/src-noconflict/theme-monokai";
export const Grid = () =>{


    return(
    
        <div id="articleContent" className="flex">
        <h2>Propriétés pour les parents</h2>
        <table>
        <thead><tr><th>Propriétés</th><th>Valeurs</th><th>Détails</th></tr></thead>
        <tr>
            <td>display</td>
            <td><ul>
                <li>inline-grid</li>
                <li>grid</li>
            </ul></td>
            <td></td>
        </tr>
        <tr>
            <td>grid-template-column</td>
            <td><ul>
                <li>1fr 2fr 5fr</li>
                <li>repeat(3,1fr)</li>
                <li>minmax(200px,1fr) minmax(50px,1fr)</li>
            </ul></td>
            <td></td>
        </tr>
        <tr>
            <td>grid-template-raw</td>
            <td>idem column</td>
            <td></td>
        </tr>
        <tr>
            <td>grid-gap</td>
            <td>10px</td>
            <td>Espace entre les élements</td>
        </tr>
        <tr>
            <td>grip-column-gap</td>
            <td>20px</td>
            <td></td>
        </tr>
        <tr>
            <td>grip-row-gap</td>
            <td>20px</td>
            <td></td>
        </tr>
        <tr>
            <td>justify-items</td>
            <td><ul>
                <li>stretch</li>
                <li>center</li>
                <li>start</li>
                <li>end</li>
            </ul></td>
            <td>Alignement axe principal</td>
        </tr>
        <tr>
            <td>align-items</td>
            <td><ul>
                <li>stretch</li>
                <li>center</li>
                <li>start</li>
                <li>end</li>
            </ul></td>
            <td>Alignement axe secondaire</td>
        </tr>
        <tr>
            <td>grid-template-areas</td>
            <td>"div1 div2 div3 div4" <br/>
            "div1 div2 div3 div4" <br/>
            "div5 div5 div5 div5" 
            </td>
            <td>Positionnement des élements</td>
        </tr>
        </table>
        <h2>Propriétés pour des enfants</h2>
        <table>
        <thead><tr><th>Propriétés</th><th>Valeurs</th><th>Détails</th></tr></thead>
         <tr>
             <td>grid-area</td>
             <td><ul>
                 <li>header</li>
                 <li>content</li>
                 <li>footer</li>
             </ul></td>
             <td>Nommage des élements</td>
         </tr>
         <tr>
             <td>align-self</td>
             <td><ul>
                 <li>stretch</li>
                 <li>center</li>
                 <li>start</li>
                 <li>end</li>
             </ul></td>
             <td>Axe principal</td>
         </tr>
         <tr>
             <td>justify-self</td>
             <td><ul>
                 <li>stretch</li>
                 <li>center</li>
                 <li>start</li>
                 <li>end</li>
             </ul></td>
             <td>Axe secondaire</td>
         </tr>
         <tr>
             <td>grid-column</td>
             <td>2</td>
             <td></td>
         </tr>
         <tr>
             <td>grid-row</td>
             <td>2</td>
             <td></td>
         </tr>
         <tr>
             <td>grid-row-start</td>
             <td>1</td>
             <td></td>
         </tr>
         <tr>
             <td>grid-column-start</td>
             <td>1</td>
             <td></td>
         </tr>
         <tr>
             <td>grid-row-end</td>
             <td>3</td>
             <td></td>
         </tr>
         <tr>
             <td>grid-column-end</td>
             <td>3</td>
             <td></td>
         </tr>
         <tr>
             <td>grid-column</td>
             <td>1/3 (grid-column-start,grid-column-end)</td>
             <td></td>
         </tr>
         <tr>
             <td>grid-raw</td>
             <td>1/3 (grid-raw-start,grid-raw-end)</td>
             <td></td>
         </tr>
         <tr>
             <td>grid-area</td>
             <td>1/1/3/3 (grid-row-start,grid-column-start,grid-row-end,grid-row-end)</td>
             <td></td>
         </tr>
        </table>
  </div>
    )
}
